import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import { Modal } from "react-bootstrap";
import CreateView from "../../common/create";
import LustrationReportsCreateViewModel from "viewModels/enforcement/lustrationReports/lustrationReportsCreateViewModel";
import LustrationReportsForm from "./lustrationReportsForm";

const LustrationReportsCreateView: ViewComponent<LustrationReportsCreateViewModel> = observer(({ vm }) => (
  <Modal scrollable show={true} onHide={vm.onHide} dialogClassName="modal-md" centered>
    <Modal.Header closeButton>
      <Modal.Title>{vm.translate("create")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <View vm={vm.alertsViewModel} useLifecycle={true} />
      <CreateView
        vm={vm}
        hideTitle={true}
        customAddText="generate"
        customButtonClassName="btn-min-width-8"
        form={<LustrationReportsForm vm={vm} />}
      />
    </Modal.Body>
  </Modal>
));

registerView(LustrationReportsCreateView, LustrationReportsCreateViewModel);
